import { Moment } from "moment-timezone";
import CalendarScheduleSlotModel from "../../models/CalendarScheduleSlotModel";

export default class CalendarScheduleRequest {
  start_time: Moment;
  end_time: Moment;
  day_of_the_week: string;
  schedule_slot_id?: number;
  date?: Moment;

  constructor(arg: CalendarScheduleSlotModel) {
    this.start_time = arg.startTime;
    this.end_time = arg.endTime;
    this.day_of_the_week = arg.dayOfWeekName;
    this.schedule_slot_id = arg?.id;
    this.date = arg.date;
  }
}
